import BaseView from "../../../js/base-view";

const SELECTOR_CLOSE = ".banner-alert__close";

export default class BannerAlert extends BaseView {
	init() {
		this.refs = {
			close: this.el.querySelector(SELECTOR_CLOSE),
		};
		this.bindEvents();
	}

	bindEvents() {
		this.on("click", SELECTOR_CLOSE, this.close.bind(this));
	}

	close() {
		this.el.style.display = "none";
	}
}
